const CreditCompanyMap: Map<number, string> = new Map([
  [0, ''],
  [1, 'オリコ'],
  [4, 'ジャックス'],
  [3, 'アプラス'],
  [6, 'セディナ'],
  [2, 'プレミア'],
  [5, 'MDF'],
  [7, 'イオン'],
  [8, '日立ｷｬﾋﾟﾀﾙ'],
  [9, 'スズキファイナンス'],
]);

export default CreditCompanyMap;



// WEBPACK FOOTER //
// ./src/app/models/plan/creditCompanyMap.ts